import { numberFormatDirective } from "./number-format/numberFormat";
import { webComponentFix } from "./web-component-fix";
import type { App } from "vue";

/**
 * Register all custom directives globally
 */
export const registerDirectives = (app: App) => {
  app.directive("number-format", numberFormatDirective);
  app.directive("web-component-fix", webComponentFix);
};

export * from "./number-format/numberFormat";
export * from "./web-component-fix";
